import React from 'react';
import TabContainer from '../../components/tab/TabContainer';
import TabDetail from './TabItems/TabDetail';
import TabVat from './TabItems/TabVat';

function DetailVoucherPC1({ data, readonly, view, selectRow, handleGetDataDetail, handleGetDataVatVao, isFieldNt }) {
	return (
		<div className="dialog__content_edit_voucher__body box_detail_voucher_detail">
			{(!view || data) && (
				<TabContainer
					tabs={[
						{
							label: 'Chi tiết',
							component: (
								<TabDetail
									data={data}
									readonly={readonly}
									handleGetDataDetail={handleGetDataDetail}
									view={view}
									selectRow={selectRow}
									isFieldNt={isFieldNt}
								/>
							),
						},
						{
							label: 'Thuế',
							component: (
								<TabVat
									data={data}
									readonly={readonly}
									handleGetDataVatVao={handleGetDataVatVao}
									view={view}
									selectRow={selectRow}
									isFieldNt={isFieldNt}
								/>
							),
						},
					]}
				/>
			)}
		</div>
	);
}

export default DetailVoucherPC1;
